// src/theme.ts
export const theme = {
    colors: {
        primary: '#B8860B',  // Dark gold color for elements
        background: '#000000', // Black background
        text: '#B8860B',       // Dark gold for text
        
        
    },
};
